import { flaggedTopic as flaggedTopicService } from '../../services';

export const ActionTypes = {
  SET_FLAGGED_TOPICS: 'SET_FLAGGED_TOPICS',
  SET_FLAGGED_TOPICS_FOR_RACE: 'SET_FLAGGED_TOPICS_FOR_RACE',
  API_ERROR: 'API_ERROR',
};

/**
 * @description action creator for getting all flagged topics
 * @param {String} raceId
 */
export const fetchAllTopicsForRace = (raceId) => {
  return async (dispatch) => {
    try {
      const flaggedTopic = await flaggedTopicService.fetchAllTopicsForRace(raceId);
      dispatch({ type: ActionTypes.SET_FLAGGED_TOPICS_FOR_RACE, payload: flaggedTopic });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_FLAGGED_TOPICS_FOR_RACE,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for getting all flagged topics
 */
export const getAllFlaggedTopics = () => {
  return async (dispatch) => {
    try {
      const flaggedTopic = await flaggedTopicService.fetchAll();
      dispatch({ type: ActionTypes.SET_FLAGGED_TOPICS, payload: flaggedTopic });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_FLAGGED_TOPICS,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for creating flagged topic
 * @param {Object} fields fields about flagged topic to create
 * @param {Function} [successCallback = () => {}] function to call on success
 * @param {Function} [failureCallback = () => {}] function to call on failure
 */
export const createFlaggedTopic = (fields, successCallback = () => {}, failureCallback = () => {}) => {
  return async (dispatch) => {
    try {
      await flaggedTopicService.createFlaggedTopic(fields);
      const flaggedTopics = await flaggedTopicService.fetchAllTopicsForRace(fields.race);
      dispatch({ type: ActionTypes.SET_FLAGGED_TOPICS_FOR_RACE, payload: flaggedTopics });
      successCallback();
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_FLAGGED_TOPICS,
          error,
        },
      });

      failureCallback(error);
    }
  };
};

/**
 * @description action creator for deleting a flagged topic
 * @param {String} id id of flagged topic object
 */
export const deleteFlaggedTopic = (id) => {
  return async (dispatch) => {
    try {
      await flaggedTopicService.deleteFlaggedTopic(id);
      const flaggedTopics = await flaggedTopicService.fetchAll();
      dispatch({ type: ActionTypes.SET_FLAGGED_TOPICS, payload: flaggedTopics });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_FLAGGED_TOPICS,
          error,
        },
      });
    }
  };
};

/**
 * @description action creator for admin approving a flagged topic
 * @param {String} id id of flagged topic object
 */
export const adminApproveFlaggedTopic = (id) => {
  return async (dispatch) => {
    try {
      await flaggedTopicService.adminApproveFlaggedTopic(id);
      const flaggedTopics = await flaggedTopicService.fetchAll();
      dispatch({ type: ActionTypes.SET_FLAGGED_TOPICS, payload: flaggedTopics });
    } catch (error) {
      dispatch({
        type: ActionTypes.API_ERROR,
        payload: {
          action: ActionTypes.SET_FLAGGED_TOPICS,
          error,
        },
      });
    }
  };
};
